import { getFloat } from '@/utils/enums';
import { number } from 'prop-types';

export const delay = (time) => new Promise((resolve) => setTimeout(() => resolve(resolve), time));

interface morninglister {
  id?: string;
  children?: moningchildren[];
}
interface moningchildren {
  actualDateNoTime?: string[];
  cmlNo?: string[];
  cabinetType?: string;
  totalBoxs?: string;
  totalVolume?: string;
  skuVariety?: string;
  show?: boolean;
  colors?: string | any;
  content?: string;
  reservationType?: string | any;
  classBG?: string | any;
  customerType?: string;
}
interface days {
  title: string;
  days: string;
}
interface infomap {
  A: Object | any;
  S: Object | any;
}
interface monthlist {
  appointmentTime?: string;
  receivingPlanWeekInfoMap?: infomap;
  res?: monthlist | any;
}

interface weekdaysList {
  title?: string;
  days?: string;
  amQty?: number;
  containerQty?: number;
  expressQty?: number;
  pmQty?: number;
  totalQty?: number;
  trunkQty?: number;
}

export default {
  state: {
    morninglister: [] as morninglister[],
    afterlist: [] as morninglister[],
    weekday: [] as days[],
    weeksel: 0 as number,
    monthList: [] as monthlist,
    weekdaysList: [] as weekdaysList[],
  },

  reducers: {
    // 设置周头部日期
    SETWEEKDAY(prevState, payload) {
      return { ...prevState, weekday: payload };
    },
    // 设置上午，下午数据
    SETWEEKLIST(prevState, payload) {
      const newarrs: any = [];
      payload.forEach((item, index) => {
        const json = {
          id: item,
          children: [],
        };
        newarrs.push(json);
      });
      return { ...prevState, morninglister: newarrs, afterlist: newarrs };
    },
    // 周数据处理
    CHECKDATAS(prevState, payload) {
      const newdata = JSON.parse(JSON.stringify(prevState));
      const list = { ...payload };
      for (const i in list) {
        list[i].forEach((item, index) => {
          if (item.status === 'C') {
            item.classBG = 'C';
          } else if (item.isOverdue === true) {
            item.classBG = 'R';
          } else if (item.reservationType === 'W') {
            item.classBG = 'W';
          } else {
            item.classBG = 'S';
          }
          newdata.morninglister.forEach((item1, index1) => {
            if (item1.id === item.actualDateNoDate && item.timeDivision === 'MN') {
              const json = { ...item };
              json.cmlNo = !json.cmlNo ? '' : json.cmlNo;
              json.totalVolume = getFloat(json.totalVolume / 1000000, 3);
              json.totalWeight = getFloat(json.totalWeight, 3);
              item1.children.push(json);
            }
          });
          newdata.afterlist.forEach((item1, index2) => {
            if (item.status === 'C') {
              item.classBG = 'C';
            } else if (item.isOverdue === true) {
              item.classBG = 'R';
            } else if (item.reservationType === 'W') {
              item.classBG = 'W';
            } else {
              item.classBG = 'S';
            }
            if (item1.id === item.actualDateNoDate && item.timeDivision === 'AN') {
              const json = { ...item };
              json.cmlNo = !json.cmlNo ? '' : json.cmlNo;
              json.totalVolume = getFloat(json.totalVolume / 1000000, 3);
              json.totalWeight = getFloat(json.totalWeight, 3);
              item1.children.push(json);
            }
          });
        });
      }
      return { ...prevState, morninglister: newdata.morninglister, afterlist: newdata.afterlist };
    },
    // 处理当前选中周还是月
    SETWEEKSEL(prevState, payload) {
      return { ...prevState, weeksel: payload };
    },
    // 月数据处理
    SETMONTHLIST(prevState, payload) {
      return { ...prevState, monthList: payload };
    },
    // 周数据统计汇总
    SETWEEKDAYLIST(prevState, payload) {
      const newprev = JSON.parse(JSON.stringify(prevState));
      if (payload.res && newprev.weekday.length) {
        for (const i in payload.res) {
          const daynums = i.substr(i.length - 2, 2);
          newprev.weekday.forEach((item, index) => {
            if (item.days === daynums) {
              item.datas = payload.res[i];
            }
          });
        }
      }
      return { ...prevState, weekday: newprev.weekday };
    },
  },

  effects: (dispatch) => ({
    // 处理 日期数据，把数据分层；先整理出日期数据、再根据日期数据整理出上午、下午数据
    async asyncDecrement(data) {
      dispatch.calender.CHECKDATAS(data);
    },
    // 设置周头部  设置日期数据
    async asyncgetweeklist(data) {
      dispatch.calender.SETWEEKDAY(data);
    },
    // 设置上午，下午数据
    async asyncsetweek(data) {
      dispatch.calender.SETWEEKLIST(data);
    },
    // 处理当前选中周还是月
    async asyncweeksel(numbers) {
      dispatch.calender.SETWEEKSEL(numbers);
    },
    // 处理月数据
    async asyncmonthList(data) {
      dispatch.calender.SETMONTHLIST(data);
    },
    // 处理周汇总数据
    async asyncsetweeklist(data) {
      dispatch.calender.SETWEEKDAYLIST(data);
    },
  }),
};
